var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsoebi2 = function SvgAsoebi2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 30.502h-4.5v-1H40v-27.7H6V4.4H5V.8h36v29.7Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 4.901h35v28.7H1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4,
    cy: 10.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 10.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 10.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4,
    cy: 19.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 19.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4,
    cy: 28.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 28.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 28.701,
    r: 2.43,
    stroke: "#000",
    strokeWidth: 0.54
  })));
};
export default SvgAsoebi2;